import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { FORM_STATUS_LABELS, FORM_STATUSES } from "../../../../util/constants";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const defaultStatuses = [
  FORM_STATUSES.DRAFT,
  FORM_STATUSES.SUBMITTED,
  FORM_STATUSES.REPORTED,
  FORM_STATUSES.REPORTED_ED_1,
  FORM_STATUSES.REPORTED_ED_2,
]

const statuses = [
  ...defaultStatuses,
  FORM_STATUSES.DELETED,
];

export default function SelectStatuses({ name, ...rest }) {
  const [formStatus, setFormStatus] = React.useState(defaultStatuses);
  const id = "status-selector";
  const labelId = id + "-label";

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setFormStatus(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  return (
    <FormControl sx={{ minWidth: "15rem" }} {...rest}>
      <InputLabel id={labelId}>Filter on Form Status</InputLabel>
      <Select
        labelId={labelId}
        id={id}
        multiple
        value={formStatus}
        required
        onChange={handleChange}
        input={<OutlinedInput label="Filter on Form Status" />}
        renderValue={(selected) => {
          if (Array.isArray(selected)) {
            return selected.map((s) => FORM_STATUS_LABELS[s]).join(", ");
          }
          return [];
        }}
        MenuProps={MenuProps}
        name={name}
      >
        {statuses.map((name) => (
          <MenuItem key={name} value={name}>
            <Checkbox checked={formStatus.includes(name)} />
            <ListItemText primary={FORM_STATUS_LABELS[name]} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
